import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from './Layout';
import ErrorBoundary from './ErrorBoundary';

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#B85C38]"></div>
  </div>
);

const PrivateRoute = () => {
  const { isAuthenticated, loading, admin, error } = useSelector((state) => state.auth);

  // Show loading spinner or placeholder while checking authentication
  // Add a timeout to prevent infinite loading
  // if (loading) {
  //   return <LoadingSpinner />;
  // }

  // If there's an error, show it
  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-md">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-red-600 mb-2">Authentication Error</h2>
            <p className="text-gray-600 mb-4">{error}</p>
            <button
              onClick={() => window.location.href = '/login'}
              className="px-4 py-2 bg-[#B85C38] text-white rounded-md hover:bg-[#B85C38]/90"
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // If authenticated, render the protected route with the layout
  return (
    <ErrorBoundary>
      <Layout>
        <Outlet />
      </Layout>
    </ErrorBoundary>
  );
};

export default PrivateRoute;
